import { z } from 'zod';
/**
 * The wire shape of a department. An allow-list, deliberately narrower than the
 * row: `tenantId` is never exposed here — it comes from the verified token,
 * never from a response body (docs/008 invariant S1/S7).
 */
export const departmentDTOSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    parentId: z.string().min(1).nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createDepartmentSchema = z.object({
    name: z.string().trim().min(1).max(120),
    parentId: z.string().min(1).nullable().default(null),
});
/**
 * Every field optional, but at least one present — a PATCH with an empty body
 * is a client bug, not a no-op update.
 *
 * `parentId` still accepts `null`: `.partial()` makes a key omittable, it does
 * not remove the `.nullable()` underneath, so "move to the root" (`null`) stays
 * distinguishable from "leave the parent alone" (key absent).
 */
export const updateDepartmentSchema = createDepartmentSchema
    .partial()
    .refine((value) => Object.keys(value).length > 0, { message: 'EMPTY_UPDATE' });
//# sourceMappingURL=department.js.map